import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {calendarDate} from 'shared/tools';
import {Table} from 'main/components';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const COLUMNS = [
  {
    header: 'nmbr.updates.directory.Field',
    width: 6,
    render: model => t(`nmbr.updates.directory.fields.${model.field}`)
  },
  {
    header: 'nmbr.updates.directory.Value',
    width: 6,
    render: model => formatValue(model)
  }
];

function formatValue(model) {
  switch (model.field) {
    case 'last_day_of_work':
      return calendarDate(model.value);
    case 'termination_type':
      return t(`models.employee.termination_type.${model.value}`);
    default:
      return model.value;
  }
}

const TerminationTable = observer(({nmbrUpdate}) => {
  if (!nmbrUpdate.hasFieldUpdate('termination')) return null;

  return (
    <div className='space-y mb2'>
      <div className='h3 medium'><FormattedMessage id='nmbr.updates.directory.Termination Details'/></div>
      <Table
        columns={COLUMNS}
        models={_.filter(nmbrUpdate.fieldUpdates, {updateType: 'termination'})}
        showLinks={false}
      />
    </div>
  );
});

export default TerminationTable;
